module.exports = __webpack_public_path__ + "media/photo/Component 8 – 12-e7f88b56.jpg";